import { render, staticRenderFns } from "./AguinaldoFiniquito.vue?vue&type=template&id=20256aec&scoped=true"
import script from "./AguinaldoFiniquito.vue?vue&type=script&lang=js"
export * from "./AguinaldoFiniquito.vue?vue&type=script&lang=js"
import style0 from "./AguinaldoFiniquito.vue?vue&type=style&index=0&id=20256aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20256aec",
  null
  
)

export default component.exports